/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_TitleInputs */

const en_directory_hubs_signals_geo_title = /** @type {(inputs: Directory_Hubs_Signals_Geo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will AI search engines cite this page?`)
};

const zh_directory_hubs_signals_geo_title = /** @type {(inputs: Directory_Hubs_Signals_Geo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 搜索引擎会引用这个页面吗？`)
};

/**
* | output |
* | --- |
* | "Will AI search engines cite this page?" |
*
* @param {Directory_Hubs_Signals_Geo_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_title = /** @type {((inputs?: Directory_Hubs_Signals_Geo_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_title(inputs)
	return zh_directory_hubs_signals_geo_title(inputs)
});
export { directory_hubs_signals_geo_title as "directory.hubs.signals.geo.title" }